import DocumentDelegate from './DocumentDelegate';
import fetchMg from './fetchManager';
import eventManger, { EventType } from './EventManager';
import _ from 'lodash';
import calenderComponent from '../components/CalenderComponent';
import { FIELD_TREE_CONSTRUCTOR_BOX } from '../components/FieldTreeConstructorBoxEvents';
import * as api from './apiUrl';
import { checkSelectedAll } from './commonUtil';
import moment from 'moment';
import { messageUtility } from './messageUtility';

moment.locale('ja');

export class DropdownSingleSelect {
  constructor(self) {
    this.component = self;
    this.keyname = 'single';

    this.field_id = 1;
    this.loadingFlag = false;
    this.loadingDisable = false;
    this.InfinityScrollEnable = true; //追加スクロール設定
    this.dropdownShow = false; //ドロップダウンが表示されているかどうか
    //プロップス
    this.props = {
      enable: true,
    };
    this.value = null;
    this.pageNumber = 0;
    //チェック状態
    this.checked = [];
    this.checkedNames = [];
    this.controlEvent = event => {
      const specifiedElement = this.component.querySelector('.dropdown__item');
      if (specifiedElement && !specifiedElement.contains(event.target)) {
        this.hideDropdown(event);
      }
    };
    this.allLoaded = false;
  }

  /**
   *
   * @param  {...any} props
   */
  setProps(props) {
    //キーを取り出してローカル変数に格納
    const keys = _.map(props, (val, key) => {
      return key;
    });
    _.each(keys, key => {
      this.props[key] = props[key];
    });
  }

  /**
   *
   * @param {*} value
   */
  setValue(value) {
    this.value = value;
  }

  /**
   * チェック項目を取得
   */
  getChecked() {
    let items = this.component.querySelectorAll(
      `.sys-${this.keyname}-select-item`
    );
    const _item = _.filter(items, item => {
      return item.checked == true;
    });
    return _item;
  }

  submit() {
    const _item = this.getChecked();

    if (_.size(_item) === 0) {
      this.pageNumber = 0;
      // 選択解除されるときに元の表示に戻す処理
      this.component.querySelector(
        '.sys-value-label'
      ).innerHTML = `${this.label}を選択`;
      this.component.querySelector(
        '.sys-value-label'
      ).value = `${this.label}を選択`;
      this.component.querySelector('.sys-value').value = null;
      this.callback(this.component, this.name, 'clear'); //args
      this.value = '0';
      this.hideDropdown();
      eventManger.trigger(EventType.DROPDOWN_MENU);
    } else {
      let _data_value = _.filter(this.data, data => {
        return data[this.api.keyid] == _item[0].value;
      });
      if (this.callback) {
        this.callback(this.component, this.name, _data_value[0]);
        if (!_data_value[0]) {
          return;
        }
        this.component.querySelector('.sys-value-label').innerHTML =
          _data_value[0].title;
        this.component.querySelector('.sys-value-label').value =
          _data_value[0].title;
        this.component.querySelector('.sys-value').value =
          _data_value[0][this.api.keyid];
        this.value = _data_value[0][this.api.keyid];
      }
      this.hideDropdown();
      eventManger.trigger(EventType.DROPDOWN_MENU);
    }
  }

  delete(e) {
    if (this.deleteCallback) {
      this.deleteCallback(e);
    }
  }

  /**
   * テンプレート
   * @param {object} value
   * @param {bool} initDropDown: ドロップダウンの初展開フラグ
   */
  tplSelectItem(value, initDropDown) {
    const checked = this.value == value[this.api.keyid] ? 'checked' : '';
    const keyidValue = _.escape(value[this.api.keyid]);
    const labelValue = _.escape(value[this.api.label]);
    const _id = _.uniqueId(`${this.keyname}_select_${this.name}_${keyidValue}`);
    const radioIcon = `
      <svg viewBox='0 0 24 24' class='icon--1_6x'>
        <path d='M0 0h24v24H0V0z' fill='none' />
        <circle cx=12 cy=12 r=9 fill='#fff' />
        <path d='M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z' />
        <circle cx=12 cy=12 r=5 />
      </svg>
    `;
    // eslint-disable-next-line no-unused-vars
    const label = () => {};
    return `<li class="${this.keyname}-select__item ${this.keyname}-select__item--radio">
              <label class="radio" for="${_id}">
                <input
                  value="${keyidValue}"
                  id="${_id}"
                  type="radio"
                  class="sys-${this.keyname}-select-item sys-check-${keyidValue}"
                  name="radio-${this.name}"
                  ${checked}
                  />
                  ${radioIcon}
                  <span onclick="document.getElementById('${_id}').checked=!document.getElementById('${_id}').checked;" class="single-select__label-text ${this.keyname}-select__label ${this.keyname}-select__label--radio">${labelValue}</span>
              </label>
            </li>`;
  }

  init() {
    //ユニークid
    this.rid = this.getRandomId();
    this.component.classList.add(this.rid);
    this.component.style.position = 'relative';
    this.selected = [];
    this.name = this.component.querySelector('.sys-value').name;
    this.name_error = `${
      this.component.querySelector('.sys-value').name
    }_error`;
    this.apiurl = this.name; //api名、初期値はnameで、setApiNameで明示的に変更する
    this.loadingFlag = false;
    this.search_word = ''; //絞り込み文字列
    this.data = [];
    //console.log("this.name = " , this.name );
    this.api = {};
    this.setProperty();
    this.addSelectButtonEvent();
    this.addInfiniteScrollEvent();
    eventManger.registerEvent(this.name);
    eventManger.registerEvent(this.name_error);
    eventManger.addEventListener(this.name_error, () => {
      this.loadingDisable = true;
      //TODO:エラーを表示する
      alert('通信エラー');
    });
  }

  setCallback(func) {
    this.callback = func;
  }

  setDeleteCallback(func) {
    this.deleteCallback = func;
  }

  setProperty() {
    if (this.component.querySelector('.sys-value')) {
      this.name = this.component.querySelector('.sys-value').name;
    }
  }

  /**
   * JSDropdown.jsx で指定した値の取得
   *  setApiUrl, setLabel
   */
  setApiUrl(apiurl) {
    if (apiurl) {
      this.apiurl = apiurl;
    }
  }

  setLabel(label) {
    if (label) {
      this.label = label;
    }
  }

  /**
   * override
   */
  checkAll() {}

  /**
   *
   */
  checkAllCheckedItems() {
    let items = this.component.querySelectorAll(
      `.sys-${this.keyname}-select-item`
    );
    _.each(items, item => {
      item.checked == false;
    });
    _.each(items, item => {
      _.each(this.checked, v => {
        if (item.value == v) {
          item.checked = true;
        }
      });
    });
  }

  /**
   * override
   */
  resetValue() {}

  /**
   * public
   */
  addSelectButtonEvent() {
    this.component.addEventListener('click', e => {
      //e.preventDefault();
      //e.stopPropagation();
      if (e.target.classList.contains(`${this.keyname}-select__label--radio`)) {
        this.submit();
      }
    });

    //ドロップダウン表示
    this.component
      .querySelector('.sys-dropdown-trigger')
      .addEventListener('mousedown', e => {
        e.preventDefault();
        e.stopPropagation();

        if (this.props.enable) {
          if (!this.dropdownShow) {
            this.showDropdown();
          } else {
            this.hideDropdown();
          }
        }
      });

    //検索入力枠の入力文字
    let wordinputEvent;
    this.component
      .querySelector('.sys-search-input')
      .addEventListener('keyup', e => {
        this.clearItems();
        this.allLoaded = false;
        eventManger.trigger(FIELD_TREE_CONSTRUCTOR_BOX.NOW_LOADING, true);
        clearTimeout(wordinputEvent);
        wordinputEvent = setTimeout(() => {
          this.search_word = e.target.value;
          this.loadingDisable = false;
          this.data = []; //リセット
          this.loadMore(() => {
            //一度データを退避
            const _data = _.cloneDeep(this.data);
            let inputValues = [];
            _.each(document.querySelectorAll('.sys-search-input'), dropDown => {
              inputValues.push(dropDown.value);
            });
            inputValues = !_.includes(inputValues, '');
            if (inputValues === true) {
              //消す
              this.clearItems();
            }
            this.data = _data;
            this.addItems(true);
          }, true);
        }, 500);
      });

    //選択ボタン
    if (this.component.querySelector('.sys-submit')) {
      this.component.querySelector('.sys-submit').addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        this.submit(e);
      });
    }

    if (this.component.querySelector('.sys-delete')) {
      this.component
        .querySelector('.sys-delete')
        .addEventListener('click', e => {
          e.preventDefault();
          e.stopPropagation();
          this.delete(e);
        });
    }

    //マルチ用全選択ボタン
    if (this.component.querySelector('.sys-multi-check')) {
      this.component
        .querySelector('.sys-multi-check')
        .addEventListener('change', e => {
          e.preventDefault();
          e.stopPropagation();
          //全選択/解除
          this.checkAll(e.target.checked);
        });
    }

    if (this.component.querySelector('.dropdown-multi-select__checkall')) {
      this.component
        .querySelector('.dropdown-multi-select__checkall span')
        .addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          //全選択/解除

          this.component.querySelector(
            '.dropdown-multi-select__checkall input'
          ).checked = !this.component.querySelector(
            '.dropdown-multi-select__checkall input'
          ).checked;

          this.checkAll(
            this.component.querySelector(
              '.dropdown-multi-select__checkall input'
            ).checked
          );
        });
    }
  }

  addInfiniteScrollEvent() {
    this.component
      .querySelector(`.dropdown-${this.keyname}-select__scroll`)
      .addEventListener('scroll', () => {
        const scrollRect = this.component
          .querySelector(`.dropdown-${this.keyname}-select__scroll`)
          .getBoundingClientRect();
        const anchorRect = this.component
          .querySelector('.sys-scroll-anchor')
          .getBoundingClientRect();
        const innerBottom = scrollRect.top + scrollRect.height;
        //スクロール内に入ったら追加ロード
        if (
          !this.loadingFlag &&
          anchorRect.bottom < innerBottom + 1 &&
          !this.loadingDisable &&
          this.InfinityScrollEnable
        ) {
          this.loadMore(() => {
            this.addItems(false);
            this.checkAllCheckedItems();
          });
        }
      });
  }

  /**
   * @param {function} callback
   * @param {bool} wordsFlag // 文字列絞り込みするかフラグ
   * 文字絞り込みした場合は追加しない
   */
  loadMore(func, wordsFlag) {
    if (this.loadingDisable || this.allLoaded) {
      eventManger.trigger(FIELD_TREE_CONSTRUCTOR_BOX.NOW_LOADING, false);
      return;
    }
    if (this.loadingFlag) return;
    this.api = api[this.apiurl](this.props);
    this.loadingFlag = true;
    const _api = api[this.apiurl](this.props);
    if (this.data.length) {
      _api.params.offset = this.data.length;
    } else {
      _api.params.offset = 0;
    }
    const searchKey = _api.searchKey || 'name';
    if (this.search_word.length) {
      _api.params[searchKey] = this.search_word;
    }

    // eslint-disable-next-line no-unused-vars
    let data = fetchMg
      .GetAjax(_api.url, _api.params, this.name)
      .then(data => {
        if (data.result == true) {
          if (wordsFlag) {
            this.data = [];
          }
          //パスから再帰で取り出す
          const datalist = (data, path) => {
            const req = (d, p) => {
              return !p.length ? d : req(d[p.shift()], p);
            };
            return req(_.cloneDeep(data), path.split('.'));
          };
          const list = datalist(data, _api.dataPath);
          if (_.isEmpty(list)) {
            this.allLoaded = true;
          } else {
            this.allLoaded = false;
            _.each(list, val => {
              let _data = _.assign({}, val);
              _data.title = val[_api.label];
              this.data.push(_data);
            });
          }
          this.loadingFlag = false;
          if (func) {
            func();
          }
          eventManger.trigger(FIELD_TREE_CONSTRUCTOR_BOX.NOW_LOADING, false);
        }
      })
      .catch(() => ({ result: false }));
  }

  //データを消す（）
  clearItems(func) {
    this.pageNumber = 0;
    this.data = [];
    this.value = null;
    this.search_word = '';
    this.component.querySelector(`.${this.keyname}-select`).innerHTML = '';
    this.component.querySelector('.sys-multi-check').checked = false;
    if (func) {
      setTimeout(() => {
        func();
      }, 100);
    }
  }

  /**
   * @param {bool} initDropDown: ドロップダウンの初展開フラグ
   * itemに一覧を追加
   */
  addItems(initDropDown) {
    if (initDropDown) {
      this.checked = _.cloneDeep(this.values);
      this.checkedNames = _.cloneDeep(this.valueNames);
    }

    this.component.querySelector(`.${this.keyname}-select`).innerHTML = '';
    let tplSelectItems = '';

    if (_.isEmpty(this.data)) {
      let messageNodata = messageUtility.getMessage('I-000-046');
      tplSelectItems = `<div class='table-has-no-data'>
                        <div class='table-has-no-data__message'>
                          ${messageNodata}
                        </div>
                      </div>`;
    } else {
      _.each(this.data, val => {
        tplSelectItems += this.tplSelectItem(val, initDropDown);
      });
      if (this.component.querySelector('.sys-multi-check')) {
        this.component.querySelector(
          '.sys-multi-check'
        ).checked = checkSelectedAll(
          _.map(this.checked, item => item.toString()),
          _.map(this.data, item => item[this.api.keyid].toString())
        );
      }
    }

    this.component.querySelector(
      `.${this.keyname}-select`
    ).innerHTML += tplSelectItems;

    let items =
      this.keyname === 'multi'
        ? this.component.querySelectorAll(`.${this.keyname}-select__item`)
        : this.component.querySelectorAll(`.sys-${this.keyname}-select-item`);

    _.each(items, item => {
      item.addEventListener('click', e => {
        e.stopPropagation();
        e.preventDefault();
        this.calcAll();
      });
    });
    this.loadingFlag = false;
  }

  /**
   * 表示
   * ここで通信する
   */
  showDropdown() {
    this.allLoaded = false;
    eventManger.trigger(FIELD_TREE_CONSTRUCTOR_BOX.NOW_LOADING, true);

    _.each(document.querySelectorAll('.dropdown'), elem => {
      elem.classList.remove('show');
    });

    const componentRect = this.component.getBoundingClientRect();
    const triggerRect = this.component
      .querySelector('.sys-dropdown-trigger')
      .getBoundingClientRect();
    this.component.style.position = 'relative';

    this.component
      .querySelector(`.dropdown-${this.keyname}-select__header`)
      .classList.add('show');
    this.component.querySelector('.dropdown-select').classList.add('show');
    this.component.querySelector('.dropdown').classList.add('show');
    this.component.querySelector('.dropdown').style.position = 'absolute';
    this.component.querySelector('.dropdown').style.zIndex = 999;
    this.component.querySelector('.dropdown').style.left = `${triggerRect.left -
      componentRect.left}px`;
    this.component.querySelector('.dropdown').style.top = `${triggerRect.top +
      triggerRect.height -
      componentRect.top}px`;
    this.data = [];
    this.loadMore(() => {
      this.addItems(true);
    });
    this.dropdownShow = true;

    window.addEventListener('mousedown', this.controlEvent);
    this.props.changeDialogHeight && this.props.changeDialogHeight(true);
  }

  hideDropdown() {
    this.allLoaded = false;
    this.component
      .querySelector(`.dropdown-${this.keyname}-select__header`)
      .classList.remove('show');
    this.component.querySelector('.dropdown-select').classList.remove('show');
    this.component.querySelector('.dropdown').classList.remove('show');
    this.component.querySelector('.dropdown').style.zIndex = -1;
    this.pageNumber = 0;
    this.dropdownShow = false;
    // handleCheckを調べたところずっとundefinedになっているのでthis.props.handleCheck()が呼ばれることがどのタイミングかわからなかった
    if (this.props.handleCheck) {
      this.props.handleCheck();
    }
    this.checked = [];
    this.checkedNames = [];
    window.removeEventListener('mousedown', this.controlEvent);
    this.props.changeDialogHeight && this.props.changeDialogHeight(false);
  }

  calcAll() {
    //チェック時にコールされる
    _.each(
      this.component.querySelectorAll(`.sys-${this.keyname}-select-item`),
      checkbox => {
        const valueName = checkbox.getAttribute('valueName');
        const index = _.indexOf(this.checked, checkbox.value);
        if (checkbox.checked) {
          if (index < 0) {
            this.checkedNames.push(valueName);
            this.checked.push(checkbox.value);
          }
        } else {
          if (index > -1) {
            this.checkedNames.splice(index, 1);
            this.checked.splice(index, 1);
          }
        }
      }
    );
    if (this.component.querySelector('.sys-multi-check')) {
      this.component.querySelector(
        '.sys-multi-check'
      ).checked = checkSelectedAll(
        _.map(this.checked, item => item.toString()),
        _.map(this.data, item => item[this.api.keyid].toString())
      );
    }
    if (this.component.querySelector('.sys-multi-check')) {
      this.submit();
    }
  }

  getRandomId() {
    var str = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var len = 10;
    var result = '';
    for (var i = 0; i < len; i++) {
      result += str.charAt(Math.floor(Math.random() * str.length));
    }
    return result;
  }
}

export class DropdownMultiSelect extends DropdownSingleSelect {
  constructor(self) {
    super(self);
    this.component = self;
    this.keyname = 'multi';
    this.uniqueId = _.uniqueId(Math.floor(Math.random() * 999));

    //TODO:現場idはEventManager経由で受け取る
    this.field_id = sessionStorage.getItem('field_id');
    this.loadingFlag = false;

    //結果が10件以内のときはスクロールの追加ローディングをしない
    this.loadingDisable = false;
    this.values = [];
    this.valueNames = [];
  }

  checkAll(b) {
    this.checked = [];
    this.checkedNames = [];
    _.each(this.component.querySelectorAll('.sys-multi-select-item'), item => {
      item.checked = b;
      if (b) {
        const valueName = item.getAttribute('valueName');
        this.checkedNames.push(valueName);
        this.checked.push(item.value);
      }
    });
    this.submit();
  }

  /**
   * 表示をリセット
   */
  resetValue() {
    this.component.querySelector(
      '.sys-value-label'
    ).innerHTML = `${this.param.label}を選択`;
    this.component.querySelector(
      '.sys-value-label'
    ).value = `${this.param.label}を選択`;
    this.component.querySelector('.sys-value').value = null;
  }

  /***
   *
   * @param {event} e
   */
  submit() {
    const values = this.checked;
    const valueNames = this.checkedNames;
    if (this.callback) {
      this.callback(this.component, this.name, values, valueNames);

      if (!values) {
        return;
      }

      //ここで入れてしまう
      const dropdownLabel = this.checked.length ? _.join(valueNames, ',') : `${this.label}を選択`;
      this.component.querySelector(
        '.sys-value-label'
      ).innerHTML = dropdownLabel;
      this.component.querySelector(
        '.sys-value-label'
      ).value = dropdownLabel;
      this.component.querySelector('.sys-value').value = values;
      this.values = values;
      this.valueNames = valueNames;
      //console.log("Dropdown submit = ",this.component.querySelector(".sys-value") ,  values );
    }
  }

  /**
   * テンプレート
   * @param {object} value
   * @param {boolean} initDropDown: ドロップダウンの初展開フラグ
   */
  tplSelectItem(value, initDropDown) {
    let checkedValues = [];
    if (initDropDown) {
      checkedValues = this.values;
    } else {
      checkedValues = this.checked;
    }
    const f = _.filter(checkedValues, v => {
      return v == value[this.api.keyid];
    });
    const checked = f.length ? 'checked' : '';
    const keyidValue = _.escape(value[this.api.keyid]);
    const labelValue = _.escape(value[this.api.label]);
    return `<li class="${this.keyname}-select__item">
            <div class="btn-checkbox">
              <label for="${this.keyname}_select_${this.uniqueId}_${this.name}_${keyidValue}">
                <input
                  value="${keyidValue}"
                  valueName="${labelValue}"
                  id="${this.keyname}_select_${this.uniqueId}_${this.name}_${keyidValue}"
                  type="checkbox"
                  class="sys-${this.keyname}-select-item sys-check-${keyidValue}"
    name="radio-${this.name}"
    ${checked}
  >
  <i class="i-square-checkbox i-2_5x" onclick="document.getElementById('${this.keyname}_select_${this.uniqueId}_${this.name}_${keyidValue}').checked=!document.getElementById('${this.keyname}_select_${this.uniqueId}_${this.name}_${keyidValue}').checked;"></i>
</label>
</div>
<div onclick="document.getElementById('${this.keyname}_select_${this.uniqueId}_${this.name}_${keyidValue}').checked=!document.getElementById('${this.keyname}_select_${this.uniqueId}_${this.name}_${keyidValue}').checked;" class="${this.keyname}-select__label">${labelValue}</div>
</li>`;
  }
}

export class DropdownSingleSelectLoader {
  constructor() {
    this.rootSelector = document.querySelector('body');
    this.components = [];
    this.callback;
    this.delegateKey = 'Dropdown';
    this.constructerQuery = '.dropdown-single-select';
    this.rootSelector = document.querySelector('body');
  }

  setRootSelector(rootSelector) {
    this.rootSelector = document.querySelector(rootSelector);
  }

  /**
   *
   * @param { dom element } component
   */
  instance(component) {
    return new DropdownSingleSelect(component);
  }

  /**
   * public
   * @param { instance of class Document } delegate
   * @param { function } func
   */
  init(delegate, func) {
    this.setDelegate(delegate);

    if (func) {
      this.callback = func;
    }

    _.each(
      this.rootSelector.querySelectorAll(this.constructerQuery),
      component => {
        //console.log("ドロップダウンコンポーネント : ",component);
        if (component) {
          let _component = this.instance(component);
          if (_component) {
            _component.init();
            _component.setCallback((element, name, value) => {
              if (this.callback) {
                this.callback(element, name, value);
              }
              this.closeAllDropdown();
            });
            this.components.push(_component);
          }
        }
      }
    );
    return this;
  }

  setDelegate(delegate) {
    delegate.setDelegate(this.delegateKey, () => {
      this.closeAllDropdown();
    });
  }

  /**
   * イベント削除
   */
  release() {
    DocumentDelegate.removeDelegate(this.delegateKey);
  }

  /**
   * 全部のドロップダウンを閉じる
   */
  closeAllDropdown() {
    _.each(this.components, component => {
      component.component.querySelector('.dropdown').classList.remove('show');
    });
  }

  /**
   * @param { dom } element
   */
  getFormListElement(element) {
    const selecter = this.targetSelecter.match(/.(.*)/i)[1];
    if (element.classList.contains(selecter)) {
      return element;
    } else {
      return this.getFormListElement(element.parentElement);
    }
  }
}

export class DropdownMultiSelectLoader extends DropdownSingleSelectLoader {
  constructor() {
    super();
    this.components = [];
    this.callback;
    this.delegateKey = 'Dropdown';
    this.constructerQuery = '.dropdown-multi-select';
  }

  /**
   *
   * @param { dom element } component
   */
  instance(component) {
    return new DropdownMultiSelect(component);
  }
}

/**
 * 番号選択セレクトのoptionを作る
 * @param {object} param
 */
export const inputSelectOptionNumbers = param => {
  let option = '';
  let n = param.start;
  let s = param.step;
  while (n <= param.max) {
    option += `<option value="${n}">${n}</option>`;
    n += s;
  }
  return option;
};

/**
 * 時間選択セレクトのoptionを作る
 * @param {*} param
 */
export const inputSelectOptionTime = param => {
  let option = '';
  let n = moment(`2018/1/1 ${param.start}`);
  let s = param.step;
  // eslint-disable-next-line no-unused-vars
  let e = moment(`2018/1/1 ${param.end}`);

  // eslint-disable-next-line no-unused-vars
  let end = false;
  // eslint-disable-next-line no-unused-vars
  let list = [];
  let i = 0;

  while (i < 100) {
    const val = n.format('HH:mm');
    option += `<option value="${val}:00">${val}</option>`;
    n.add(s, 'm');
    i++;
  }
  return option;
};

/**
 * A-Zセレクトのoptionを作る
 * @param {object} param
 */
export const inputSelectOptionAZ = () => {
  let option = '';
  let param = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  for (let i = 0; i < param.length; i++) {
    const n = param.charAt(i);
    option += `<option value="${n}">${n}</option>`;
  }
  return option;
};

/**
 * カレンダーの情報を管理するクラス
 */
export class DropdownCalendarLoader extends DropdownSingleSelectLoader {
  constructor() {
    super();
    this.components = [];
    this.callback;
    this.delegateKey = 'Dropdown';
    this.constructerQuery = '.sys-input-dropdown-calender';
  }

  /**
   * @param { dom element } component
   */
  instance(component) {
    //すでにオブジェクトが作られていたら作らない
    let genFlag = true;
    _.each(component.classList, classname => {
      if (classname.match(/^cal-.*/)) {
        genFlag = false;
      }
    });
    return genFlag ? new calenderComponent(component) : null;
  }

  setDelegate(delegate) {
    delegate.setDelegate(this.delegateKey, () => {
      this.closeAllDropdown();
    });
  }

  /**
   * 全部のドロップダウンを閉じる
   */
  closeAllDropdown() {
    _.each(this.components, component => {
      component.component
        .querySelector('.dropdown-calender')
        .classList.remove('show');
    });
  }
}



// WEBPACK FOOTER //
// ./src/utilities/formComponents.js